/**
 * Where the creator API lives. Shared by everything that talks to it — the REST client and the hub
 * connection both build their URLs from here, so neither has to reach into the other for it.
 */
export const creatorApiBaseURL =
  process.env.REACT_APP_ENV_API && process.env.REACT_APP_ENV_API.trim() !== '' ? process.env.REACT_APP_ENV_API + '/creatorAPI/' : 'https://niastest02.norskinteraktiv.no/creatorAPI/';

//export const creatorApiBaseURL = process.env.REACT_APP_CREATOR_API_URL ?? '';
